import React, { useState, useEffect } from "react";

const Carousel = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const wrapperStyle = {
    width: "100%",
    height: isMobile ? "50vh" : "70vh",
    objectFit: "cover",
  };

  return (
    <div
      id="carouselExampleDark"
      className="carousel carousel-dark slide"
      data-bs-ride="carousel"
      data-bs-interval="3000"
      style={{ paddingTop: "80px" }}
    >
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active" data-bs-interval="10000">
          <img
            src="/static/dashboard1.jpg"
            className="d-block w-100"
            alt="First Slide"
            style={wrapperStyle}
          />
          <div
            className="carousel-caption d-block"
            style={{ bottom: isMobile ? "10%" : "20%" }}
          >
            <div id="contentCarousel">
              <h5
                style={{
                  fontSize: isMobile ? "1.5rem" : "3rem",
                  fontWeight: "bold",
                }}
              >
                <span style={{ color: "rgb(0, 0, 0)" }}>Welcome To </span>
                <span style={{ color: "#00d8cb" }}>Telsa Super Apps</span>
              </h5>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1.5rem",
                  color: "rgb(0, 0, 0)",
                }}
              >
                Telsa Super Apps merupakan platform traceability untuk industri
                sawit sebagai media menulusuri asal bahan baku dari crude palm
                oil atau CPO.
              </p>
            </div>
          </div>
        </div>

        <div className="carousel-item">
          <img
            src="/static/Dashboard.jpg"
            className="d-block w-100"
            style={wrapperStyle}
            alt="Second Slide"
          />
          <div
            className="carousel-caption d-block"
            style={{ bottom: isMobile ? "10%" : "20%" }}
          >
            <div id="contentCarousel">
              <h5
                style={{
                  fontSize: isMobile ? "1.5rem" : "3rem",
                  fontWeight: "bold",
                }}
              >
                <span style={{ color: "rgb(0, 0, 0)" }}>
                  Platform Logistik{" "}
                </span>
              </h5>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1.5rem",
                  color: "rgb(0, 0, 0)",
                }}
              >
                Platform logistik ini mendukung perusahaan dalam industri sawit
                untuk membangun sistem ketelusuran dan transparansi dalam
                operasi logistik, serta memastikan pengiriman yang tepat waktu
                dan efisien.
              </p>
            </div>
          </div>
        </div>

        <div className="carousel-item">
          <img
            src="/static/parbiksawit.jpg"
            className="d-block w-100"
            style={wrapperStyle}
            alt="Third Slide"
          />
          <div
            className="carousel-caption d-block"
            style={{ bottom: isMobile ? "10%" : "20%" }}
          >
            <div id="contentCarousel">
              <h5
                style={{
                  fontSize: isMobile ? "1.5rem" : "3rem",
                  fontWeight: "bold",
                }}
              >
                <span style={{ color: "rgb(0, 0, 0)" }}>Industri Sawit </span>
              </h5>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1.5rem",
                  color: "rgb(0, 0, 0)",
                }}
              >
                Platform ini membantu suatu perusahaan atau industri sawit dalam
                membangun sistem ketelusuran dan transparansi produk kelapa
                sawit.
              </p>
            </div>
          </div>
        </div>
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleDark"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleDark"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
